(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-stoic-collection-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      if (!response.ok) throw new Error('Cart error');

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          source: 'stoic-collection-grid',
          data: {
            source: 'stoic-collection-grid'
          }
        }
      }));

      button.textContent = 'ADDED ✓';

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1200);
    } catch (error) {
      button.textContent = 'TRY AGAIN';
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
